import { render, staticRenderFns } from "./AktifBolgeEkle.vue?vue&type=template&id=719d4a65&scoped=true"
import script from "./AktifBolgeEkle.vue?vue&type=script&lang=js"
export * from "./AktifBolgeEkle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719d4a65",
  null
  
)

export default component.exports